module.exports = __webpack_public_path__ + "assets/img/y2.d88b8551.png";